import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20stacked%20colorful%20manga%20books%20and%20open%20comic%20pages%20floating%20with%20warm%20glow%20and%20sakura%20petals%2C%20coral%20and%20cream%20palette%2C%20cozy%20reading%20atmosphere%2C%20high%20detail%2C%20wide%20banner&width=1600&height=640&seq=cta-2026-x1&orientation=landscape"
        alt="开始阅读漫画背景"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/45"></div>
      <div className="relative z-10 mx-auto px-4 md:px-6 max-w-4xl py-16 md:py-24 text-center text-background-50">
        <h2 className="text-2xl md:text-4xl font-heading">即刻开启你的漫画之旅</h2>
        <p className="mt-3 text-sm md:text-base text-background-100">
          分类浏览 + 人气榜，热门推荐、完结榜、新作一网打尽，随时随地畅读海量好漫画。
        </p>
        <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/rexue"
            className="px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-primary-600"
          >
            开始阅读
          </Link>
          <Link
            to="/category/hot"
            className="px-6 py-3 rounded-full bg-background-50/15 border border-background-50/30 text-sm font-semibold whitespace-nowrap hover:bg-background-50/25"
          >
            查看人气榜
          </Link>
        </div>
      </div>
    </section>
  );
}